<template>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="search"
            label="Pesquisar nome ou email"
            prepend-icon="mdi-magnify"
            @input="fetchUsers"
            dense
            outlined
            solo
            rounded
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="filteredUsers"
            item-key="id"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Gestão de Utilizadores</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
              </v-toolbar>
            </template>
            <template v-slot:item.is_active="{ item }">
              <v-switch
                v-model="item.is_active"
                @change="updateUserStatus(item)"
                :label="item.is_active ? 'Activo' : 'Inactivo'"
              ></v-switch>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>

    import User from '@/api/User.js';
  
  export default {
    name: 'SuperAdmin',
    data() {
      return {
        search: '',
        users: [],
        headers: [
          { text: 'Nome', value: 'name' },
          { text: 'Email', value: 'email' },
          { text: 'Último Login', value: 'last_login_at' },
          { text: 'Ativo', value: 'is_active' }
        ]
      };
    },

    computed: {
      filteredUsers() {
        if (!this.search) {
          return this.users;
        }
        const searchLower = this.search.toLowerCase();
        return this.users.filter(user =>
          user.name.toLowerCase().includes(searchLower) ||
          user.email.toLowerCase().includes(searchLower)
        );
      }
    },

    mounted(){

        if(!this.$root.session.hasPermission(["super"])) {
        this.$router.push('/no-permission');
        }

        this.fillBaseData();

    },

    methods: {
      async fetchUsers() {
        try {
          const response = await User.list();
          this.users = response.data;
        } catch (error) {
          console.error('Erro ao buscar usuários:', error);
        }
      },
    async updateUserStatus(user) {
      try {
        const params = {
        id: user.id,
        is_active: user.is_active
        };

        await User.update(params);
        this.$toast.success('Status do usuário atualizado com sucesso.');
      } catch (error) {
        console.error('Erro ao atualizar status do usuário:', error);
        this.$toast.error('Erro ao atualizar status do usuário.');
      }
    }
    },
    created() {
      this.fetchUsers();
    }
  };
  </script>
  
  <style scoped>
  
  </style>